module.exports = __webpack_public_path__ + "static/media/bg_middle.b816d2a2.png";